import React from "react";
import { Fragment } from "react";

import { Container } from "../../components";
import { lazyWithRetry } from "../../core/lazy_with_retry";
import { TemplateOfferingListingDayPass } from "../template_offering_listing_daypass";
import { Text } from "../text";
import { faqsEN } from "./offering_wework_day_office";
import { useWeWorkAnalytics } from "./wework_analytics";
import { useWeWorkPartnerConfig } from "./wework_partner_config";

const Theme = lazyWithRetry(() => import("./wework_theme"));

export function OfferingWeWorkListingDayPass() {
  useWeWorkAnalytics();
  const partnerConfig = useWeWorkPartnerConfig();
  return (
    <Fragment>
      <Theme />
      <TemplateOfferingListingDayPass
        showTalkWithUsPrompt={false}
        partnerConfig={{
          ...partnerConfig,
          title: "Daily Access",
        }}
        data={{
          faqs: faqsEN,
          description: (
            <Container>
              <Text>
                WeWork Daily Access provides you with a coworking space when you
                need it, without a long term commitment. Whether you’re tackling
                to-do’s or kicking off a project, you’ll have the space,
                community, and amenities to work towards your goals. Reserve
                your spot in advance, check-in, and get straight to work.
              </Text>
            </Container>
          ),
        }}
      />
    </Fragment>
  );
}
